import React, { useState } from "react";
import { useQuery } from "react-query";
import { Link } from "react-router-dom";

import { FiSearch } from "react-icons/fi";
import { TiUserDelete } from "react-icons/ti";
import { Button } from "reactstrap";

import apiService from "services/api";
import { CustomTable, CustomAlert } from "components";
import { useNotificationContext } from "contexts";
import { studentTableColumns } from "./constants";

const StudentPage = () => {
	const { isLoading, data: students, refetch } = useQuery(["students"], () => apiService.student.getAbsoluteMin());

	const { createNotification } = useNotificationContext();

	const [studentToDeactivate, setStudentToDeactivate] = useState({
		firstName: "",
		lastName: "",
		id: "",
	});

	const [displayConfirmationModal, setDisplayConfirmationModal] = useState(false);

	const showDeleteModal = (studentToDeactivate) => {
		setStudentToDeactivate(studentToDeactivate);
		setDisplayConfirmationModal(true);
	};

	// Hide the modal
	const hideConfirmationModal = () => setDisplayConfirmationModal(false);

	// Handle the actual deletion of the item
	const submitDelete = async () => {
		await apiService.student
			.delete(studentToDeactivate.id)
			.then(() => {
				createNotification({
					type: "success",
					message: "Successfully deleted member",
				});
				refetch();
			})
			.catch((error) => createNotification({ type: "danger", message: error.message }));
		setDisplayConfirmationModal(false);
	};

	const actions = (row) => (
		<div className="actions-right">
			<Link to={`/student/${row.id}`}>
				<Button color="warning" size="sm" className="btn-icon btn-link edit">
					<FiSearch size={20} />
				</Button>
			</Link>
			{/* todo, delete parent and validation */}
			{/* <Link to={`/parent/delete/${row.id}`}> */}
			<Button color="warning" size="sm" className="btn-icon btn-link edit" onClick={() => showDeleteModal(row)}>
				<TiUserDelete className="text-danger" size={20} />
			</Button>
			{/* </Link> */}
		</div>
	);

	return (
		<div className="content">
			<div className="mt-3">
				<div className="d-flex mb-2">
					<Link to={`/student/new`}>
						<button type="button" className="btn btn-info">
							Add new student
						</button>
					</Link>
				</div>

				<CustomAlert
					title="Remove Member"
					show={displayConfirmationModal}
					hideModal={hideConfirmationModal}
					description={
						<>
							Are you sure you want to deactivate student{" "}
							<span className="text-danger font-weight-bold">
								{studentToDeactivate.firstName} {studentToDeactivate.lastName}?
							</span>
						</>
					}
					submitModal={submitDelete}
					submitButtonText="Delete"
				/>

				<CustomTable data={students} columns={studentTableColumns} defaultPageSize={25} title="Students" actions={actions} loading={isLoading} />
			</div>
		</div>
	);
};

export default StudentPage;
